var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-wrapper"},[_c('Menu'),_vm._v(" "),_c('div',{staticClass:"auth-content"},[_c('div',{staticClass:"auth-area"},[_c('Logo'),_vm._v(" "),_c('Welcome')],1)]),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }